import i18next from 'i18next';

// Suffix appended to per-page titles via React Helmet — e.g. a dashboard
// page renders `<title>Dashboard - CAS Shield</title>`. The product name
// resolves through i18next so an AU uni's region pack (or any per-uni override)
// can rebadge it (e.g. to "CoE Shield"). Read at call-time rather than module
// load because i18next isn't initialised yet when this module first evaluates.
export function titleAppend(): string {
  // eslint-disable-next-line import/no-named-as-default-member
  const productName = i18next.t('common:productName', { defaultValue: 'CAS Shield' });
  return `- ${productName}`;
}
